import React from 'react'
import { Col, Row } from 'react-bootstrap'
import BadgeCard from './BadgeCard'

const ListaAnimaciones = () =>{
    return(
        <div className = "bg-svg py-4 ">
            <div className = "container ">
                <div className = "text-center text-white">
                    <h1>Animaciones</h1>
                    <p>Proyectos visualmente atractivos</p>
                </div>
                <Row xs={1} md={4} className="g-4">
                    <Col>
                        <BadgeCard  badgeColor = "bg-primary" title = "Botón animado" p = "Un botón visualmente atractivo con css y html" Link = "/boton"/>
                    </Col>
                    <Col>
                        <BadgeCard badgeColor = "bg-info" title = "Reloj digital" p = "Un reloj con formato digital, fue un ejemplo para aprender a usar lo básico de desarrollo web" Link = "/reloj-digital"/>
                    </Col>
                    <Col>
                        <BadgeCard badgeColor = "bg-success" title = "Reloj analógico" p = "Un reloj utilizando un formato analógico, aquí se utilizó la etiqueta canvas de html5" Link = "/reloj-analogico"/>
                    </Col>
                    <Col>
                        <BadgeCard badgeColor = "bg-danger" title = "Círculos" p = "Una animación utilizando las pseudoclases de css" Link = "/circulos"/>
                    </Col>
                    
                </Row>
            </div>
        </div>
    )
}
export default ListaAnimaciones